<template>
  <div class="contract-phone-lookup">
    <label :for="inputId" class="form-label">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>
    <div class="input-group">
      <input
        :id="inputId"
        :value="mobile"
        class="form-control contract-phone"
        type="tel"
        inputmode="tel"
        autocomplete="off"
        maxlength="24"
        :disabled="disabled"
        :placeholder="placeholder"
        :aria-describedby="`${inputId}-feedback`"
        @input="phoneChanged"
        @keydown.enter.prevent="lookup"
      />
      <button
        type="button"
        class="btn btn-outline-primary"
        :disabled="disabled || searching || !mobile"
        @click="lookup"
        :aria-label="`بحث عن ${label}`"
      >
        <span v-if="searching" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <i v-else class="bi bi-search" aria-hidden="true"></i>
      </button>
    </div>
    <div :id="`${inputId}-feedback`" aria-live="polite" class="mt-2 small">
      <div v-if="searching" class="text-muted">جارٍ البحث بالرقم...</div>
      <div v-else-if="modelValue" class="contract-resolved">
        <i class="bi bi-person-check-fill" aria-hidden="true"></i>
        <div>
          <strong>{{ modelValue.name }}</strong>
          <span class="d-block contract-phone">{{ modelValue.mobile || modelValue.mobileNumber }}</span>
        </div>
      </div>
      <div v-else-if="message" class="text-danger">{{ message }}</div>
      <div v-else class="text-muted">أدخل رقم الجوال المسجل لعرض الاسم تلقائياً.</div>
    </div>
  </div>
</template>

<script>
import { normalizePhone } from './helpers';

export default {
  name: 'ContractPhoneLookup',
  props: {
    modelValue: { type: Object, default: null },
    label: { type: String, required: true },
    inputId: { type: String, required: true },
    disabled: Boolean,
    required: { type: Boolean, default: true },
    placeholder: { type: String, default: '05xxxxxxxx' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      mobile: this.modelValue?.mobile || this.modelValue?.mobileNumber || '',
      searching: false,
      message: '',
      timer: null,
      serial: 0,
    };
  },
  watch: {
    modelValue(value) {
      if (value) {
        this.serial += 1;
        this.searching = false;
        clearTimeout(this.timer);
        this.message = '';
        this.mobile = value.mobile || value.mobileNumber || '';
      }
    },
  },
  methods: {
    phoneChanged(event) {
      this.mobile = event.target.value;
      this.serial += 1;
      this.searching = false;
      this.message = '';
      clearTimeout(this.timer);
      this.$emit('update:modelValue', null);
      if (/^05\d{8}$/.test(normalizePhone(this.mobile))) this.timer = setTimeout(() => this.lookup(), 400);
    },
    async lookup() {
      if (this.disabled || this.searching) return;
      clearTimeout(this.timer);
      const mobile = normalizePhone(this.mobile);
      if (!/^05\d{8}$/.test(mobile)) {
        this.message = 'أدخل رقم جوال سعودي صحيح، مثل 05xxxxxxxx أو +9665xxxxxxxx';
        return;
      }
      const serial = ++this.serial;
      this.searching = true;
      this.message = '';
      this.$emit('update:modelValue', null);
      try {
        const { data } = await this.$http.post('/api/admin/contracts/lookup/client', { mobile });
        if (serial !== this.serial) return;
        const person = data.client;
        if (!person?.id) throw new Error('لم يتم العثور على بيانات مطابقة للرقم');
        this.$emit('update:modelValue', person);
      } catch (error) {
        if (serial === this.serial) this.message = this.$globalError(error);
      } finally {
        if (serial === this.serial) this.searching = false;
      }
    },
  },
  beforeUnmount() {
    clearTimeout(this.timer);
    this.serial += 1;
  },
};
</script>
